import React from "react";
import EventButton, {
  EventButtonVariant,
} from "../../shared/components/EventButton";
import CommunityNavigationStore from "../../navigation/communityNavigationStore";
import { SendSetupsConfirmationContent } from "./SetupsPopUp";

interface SendSetupsButtonProps {
  hasSetups: boolean;
  onSendNow: () => void;
}

const SendSetupsButton: React.FC<SendSetupsButtonProps> = ({
  hasSetups,
  onSendNow,
}) => {
  if (!hasSetups) {
    return null;
  }

  return (
    <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 w-full max-w-md px-6">
      <EventButton
        onClick={() => {
          CommunityNavigationStore.setPopUpView({
            onClose: () => {
              CommunityNavigationStore.setPopUpView(null);
            },
            children: (
              <SendSetupsConfirmationContent
                onSendNow={() => {
                  CommunityNavigationStore.setPopUpView(null);
                  onSendNow();
                }}
              />
            ),
          });
        }}
        variant={EventButtonVariant.PRIMARY_WHITE}
        className="w-full text-lg py-4"
        icon="🤩"
      >
        Send out setups
      </EventButton>
    </div>
  );
};

export default SendSetupsButton;
